import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PaginatedEvent } from "@models/pagination_event";
import { PRICES_SCROLL_PER_PAGE } from "@helpers/constants";
import { PricesAsset, PricesScrollService } from "@main-services/prices-scroll.service";
import { Timespan } from "@helpers/const/timespan";

@Injectable()
export class PricesInfiniteScrollFacade {
	public constructor(private readonly pricesScrollService: PricesScrollService) {}

	public initList(): void {
		this.pricesScrollService.initList();
	}

	public getList$(): Observable<PricesAsset[]> {
		return this.pricesScrollService.getListObservable();
	}

	public updateList(
		sortColumn: string,
		sortDir: string,
		timeframe: Timespan,
		filter: string,
		search: string,
		tags: number[]
	): void {
		this.pricesScrollService.clearEndOfList();
		const event = new PaginatedEvent();

		if (sortColumn && sortDir) {
			if (sortColumn === "change") {
				// Api syntax adjustment:
				switch (timeframe) {
					case Timespan.Week:
						sortColumn = "price_change_1w";
						break;
					case Timespan.Month:
						sortColumn = "price_change_1m";
						break;
					case Timespan.Year:
						sortColumn = "price_change_1y";
						break;
					case Timespan.SixMonths:
						sortColumn = "price_change_6m";
						break;
					case Timespan.FiveYears:
						sortColumn = "price_change_5y";
						break;
					default:
						sortColumn = "price_change_24h";
						break;
				}
			}

			event.setSortBy(sortColumn.toLowerCase());
			event.setSortDirection(sortDir);
		}

		if (filter) {
			event.setType([filter.toLowerCase()]);
		}

		if (search) {
			event.setSearchQuery(search);
		}

		event.setPageSize(PRICES_SCROLL_PER_PAGE);
		event.setTags(tags);

		this.pricesScrollService.fetchApiData(event);
	}

	public refetchList(filter: string): void {
		this.pricesScrollService.refetchList([filter]);
	}

	public fetchNextPage(): void {
		this.pricesScrollService.fetchListUpdate();
	}

	public getLoadingObservable$(): Observable<boolean> {
		return this.pricesScrollService.getLoadingObservable();
	}

	public getErrorObservable$(): Observable<boolean> {
		return this.pricesScrollService.getFetchErrorObservable();
	}
}
